import type { SearchResultContact } from "@/features/meetings/services/contacts.api"

/**
 * Pick the peer out of however many directory searches came back.
 *
 * `resultsByScope` is ordered narrowest first (sub-org, org, global): the
 * first list that actually contains this id wins, so a person findable at
 * the sub-org level is never shadowed by a same-named stranger further out.
 * A `null` entry stands for a search that failed or was skipped and is
 * passed over rather than treated as a miss worth stopping on.
 */
export function pickPeerEntry(
  resultsByScope: Array<SearchResultContact[] | null>,
  peerId: string,
): { email?: string; orgName?: string } | null {
  for (const contacts of resultsByScope) {
    if (!contacts) continue
    const hit = contacts.find((c) => c.id === peerId)
    if (hit) return { email: hit.email, orgName: hit.contactOrgName }
  }
  return null
}
